module.exports = __webpack_public_path__ + "static/portfolio-10-a790683d088f4b7a6bac59a4078f79c6.jpg";